import React, {PureComponent} from 'react';
import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';

import './FilterRequirements.scss';

class FilterRequirements extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showDrop: false,
      title: this.getTitle(props.value),
      value: props.value ? parseInt(props.value, 10) : null,
    };
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (this.props.value !== prevProps.value) {
      this.setState({
        value: this.props.value,
        title: this.getTitle(this.props.value),
      })
    }
  }

  onChange = (value) => {
    this.setState({
      title: this.getTitle(value),
      value: value.value ? value.value : null,
    });
    this.props.onChange(value.value);
  };

  dropDown = () => {
    this.setState({showDrop: !this.state.showDrop});
  };

  getTitle = (value) => {
    let text = 'Défaut';
    this.props.choices.forEach((choice) => {
      if(choice.value === parseInt(value, 10)) {
        text = choice.text;
      }
    });

    return text;
  };

  render() {
    return (
      <div className="filter filter-requirements">
        <Dropdown
          className=""
          isOpen={this.state.showDrop}
          toggle={() => this.dropDown()}>
          <DropdownToggle caret className={this.state.value ? 'btn-color' : 'btn-transparent'}>
            {this.state.title}
          </DropdownToggle>
          <DropdownMenu className={this.state.showDrop ? 'show' : ''}>
            {this.props.choices.map((value, id) => (
              <DropdownItem
                key={id}
                onClick={() => this.onChange(value)}
              >
                {value?.text ?? ''}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  }
}

export default FilterRequirements;